import { ChevronRight } from "lucide-react";

export const SettingsCard = ({
  icon: Icon,
  label,
  onClick,
  rightElement,
}: {
  icon: React.ElementType;
  label: string;
  onClick?: () => void;
  rightElement?: React.ReactNode;
}) => (
  <div
    className="group w-full bg-white rounded-xl shadow-sm p-4 md:p-6 hover:bg-gradient-to-r hover:from-[#5050EA] hover:to-[#85A2FF] transition-all"
    onClick={onClick}
  >
    <div className="flex items-center justify-between bg-white rounded-lg p-3 md:p-4 cursor-pointer group-hover:bg-gradient-to-r hover:from-[#5050EA] hover:to-[#85A2FF] transition-all">
      <div className="flex items-center space-x-3 md:space-x-4 flex-1 min-w-0">
        <Icon className="text-[#6A6A6A] group-hover:text-white flex-shrink-0 w-5 h-5 md:w-6 md:h-6" />
        <span className="text-[#6A6A6A] group-hover:text-white text-sm md:text-base font-medium truncate">
          {label}
        </span>
      </div>
      <div className="flex-shrink-0 ml-2">
        {rightElement || (
          <ChevronRight className="text-gray-400 group-hover:text-white w-5 h-5 md:w-6 md:h-6" />
        )}
      </div>
    </div>
  </div>
);
